/**
 * Confirmed Booking Page - Shown after successful Cal.com booking
 * Includes Meta Pixel tracking
 */

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2 } from 'lucide-react';

const ConfirmedBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const formData = location.state?.formData || {};
  const bookingId = location.state?.bookingId;

  // Initialize Meta Pixel
  useEffect(() => {
    // Meta Pixel Code
    (function(f: any, b: any, e: string, v: string, n: any, t: any, s: any) {
      if ((f as any).fbq) return;
      n = (f as any).fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!(f as any)._fbq) (f as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    );

    // Initialize and track PageView
    (window as any).fbq('init', '2729315417438617');
    (window as any).fbq('track', 'PageView');
  }, []);

  return (
    <>
      {/* Meta Pixel Noscript */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=2729315417438617&ev=PageView&noscript=1"
          alt=""
        />
      </noscript>

      <div className="min-h-screen bg-slate-900 flex items-center justify-center py-12">
        <div className="container mx-auto px-4 max-w-2xl">
          <Card className="p-8 text-center bg-slate-800/80 border-slate-700 text-white shadow-xl">
            <div className="w-20 h-20 bg-amber-500/20 border border-amber-500/50 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle2 className="w-12 h-12 text-amber-400" />
            </div>
            
            <h1 className="text-3xl font-bold mb-4 text-white">Booking Confirmed!</h1>
            
            <p className="text-slate-400 mb-6">
              Thank you, {formData.firstName}! Your consultation has been scheduled.
            </p>
            
            {bookingId && (
              <p className="text-sm text-slate-500 mb-8">
                Booking ID: {bookingId}
              </p>
            )}
            
            <div className="space-y-4">
              <p className="text-lg text-slate-300">
                We've sent a confirmation email to <strong className="text-amber-400">{formData.email}</strong> with all the details.
              </p>
              
              <p className="text-slate-400">
                Our team will be in touch shortly to prepare for your consultation.
              </p>
            </div>
            
            <Button
              onClick={() => navigate('/')}
              className="mt-8 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold"
            >
              Return Home
            </Button>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ConfirmedBooking;
